import React from 'react'
import { View, Text, StyleSheet } from '@react-pdf/renderer'
import MeterView from './MeterView'

const progressLookup = {
    "NotRelevant": "Toimenpide ei ole enää ajankohtainen",
    "NoProgress": "Toimenpiteen toteutus ei etene odotetusti",
    "NotAsFast": "Toimenpiteen toteutus etenee odotettua hitaammin",
    "AsPlanned": "Toimenpiteen toteutus etenee odotetusti",
    "Faster": "Toimenpiteen toteutus etenee odotettua nopeammin",
    "CompletelyAchieved": "Toimenpide on kokonaan toteutunut"
}

const operationBody = ({operation}) => {
    return(
        <View>
            <Text style={styles.boldText}>
                {operation.name}
            </Text>

            <Text style={styles.h3}>
                Toimenpiteen mittarit
            </Text>

            {operation.meters.map(meter =>
                <MeterView
                    key={meter.meterId}
                    meter={meter}
                />
            )}

            {/* Operation's report text */}
            <Text style={{fontSize: 10, marginBottom: 10}}>
                {operation.reportText}
            </Text>

            {/* Operation's progress */}
            <Text style={{fontSize: 10, marginBottom: 5}}>
                {progressLookup[operation.progress]}
            </Text>
        </View>
    )
}

export default operationBody

const styles = StyleSheet.create({
    body: {
        paddingTop: 35,
        paddingBottom: 65,
        paddingHorizontal: 35,
    },
    headerWithBorder: {
        fontSize: 20,
        paddingBottom: 10,
        borderBottom: '1px solid grey',
        marginBottom: 10,
    },
    h3: {
        fontSize: 12,
    },
    boldText: {
        fontSize: 12,
        fontWeight: 'bold',
        marginBottom: 5,
    },
    text: {
        fontSize: 10,
    },
    
})


// WEBPACK FOOTER //
// ./src/components/printable/OperationBody.jsx